import React, { useEffect, useState, useRef } from 'react';
import './Footer.css'
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png'
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faDownload, faArrowUp } from '@fortawesome/free-solid-svg-icons';
export default function Footer() {
    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [contactos, setContactos] = useState([]);
    const [pwaConfig, setPwaConfig] = useState(null);
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isStandalone, setIsStandalone] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        const checkStandalone = () => {
            const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone || localStorage.getItem('pwa_installed') === 'true';
            setIsStandalone(!!standalone);
        };

        checkStandalone();
        cargarProductos();
        cargarConfigPWA();

        // Verificar si ya fue capturado globalmente
        if (window.deferredPrompt) {
            setDeferredPrompt(window.deferredPrompt);
        }

        const handlePromptAvailable = () => {
            if (window.deferredPrompt) {
                setDeferredPrompt(window.deferredPrompt);
            }
        };

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };

        const handleAppInstalled = () => {
            setIsStandalone(true);
        };

        window.addEventListener('pwa-prompt-available', handlePromptAvailable);
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', handleAppInstalled);

        return () => {
            window.removeEventListener('pwa-prompt-available', handlePromptAvailable);
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);
    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const categoriasMap = new Map();
                data.productos.forEach(producto => {
                    const categoria = producto.categoria;
                    if (categoriasMap.has(categoria)) {
                        categoriasMap.get(categoria).push(producto);
                    } else {
                        categoriasMap.set(categoria, [producto]);
                    }
                });
                const categoriasArray = Array.from(categoriasMap, ([categoria, productos]) => ({ categoria, productos }));
                setCategorias(categoriasArray?.slice(0, 3));
                setProductos(data.productos?.slice(0, 3));
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    useEffect(() => {
        cargarContacto();

    }, []);


    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarConfigPWA = () => {
        fetch(`${baseURL}/pwaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setPwaConfig(data.pwa);
            })
            .catch(error => console.error('Error al cargar configuración PWA:', error));
    };

    const handleInstallApp = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('Usuario aceptó la instalación');
                } else {
                    console.log('Usuario rechazó la instalación');
                }
                setDeferredPrompt(null);
            });
        } else {
            window.dispatchEvent(new CustomEvent('show-pwa-install-modal'));
        }
    };


    return (
        <>
            <div className='FooterContain'>
                <div className='footerText'>
                    <Anchor to='' target="_blank">   <img src={logo} alt="logo" /></Anchor>
                    <h2>
                        {contactos.nombre}
                    </h2>
                    {pwaConfig && pwaConfig.activo === 1 && !isStandalone && (
                        <button className='btnDownloadApp' onClick={handleInstallApp}>
                            <FontAwesomeIcon icon={faDownload} /> Descargar App
                        </button>
                    )}
                    <div className='socials'>
                        <Anchor to={contactos.instagram} target="_blank"><i className='fa fa-instagram'></i></Anchor>
                        <Anchor to={`tel:${contactos.telefono}`} target="_blank"><i className='fa fa-whatsapp'></i></Anchor>
                        <Anchor to={contactos.facebook} target="_blank"><i className='fa fa-facebook'></i></Anchor>

                    </div>
                </div>
                <div className='footerText'>
                    <h3>Contacto</h3>
                    <Anchor to={`mailto:${contactos.email}`} target="_blank">{contactos.email}</Anchor>
                    <Anchor to={`tel:${contactos.telefono}`} target="_blank">{contactos.telefono}</Anchor>
                    <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(contactos.direccion)}`} target="_blank">{contactos.direccion}</Anchor>

                </div>
                <div className='footerText'>
                    <h3>Productos</h3>
                    {
                        productos?.map(item => (
                            <Anchor key={item?.idProducto} to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`} >
                                {item?.titulo?.slice(0, 33)}
                            </Anchor>
                        ))
                    }

                </div>
                <div className='footerText'>
                    <h3>Acceso</h3>
                    <div className='acceso-wrapper'>
                        <Anchor to={`/dashboard`} className='btnAnch'>
                            <FontAwesomeIcon icon={faUser} /> Administrador
                        </Anchor>
                        <button onClick={scrollToTop} className='btnScrollTop' aria-label="Subir página">
                            <FontAwesomeIcon icon={faArrowUp} />
                        </button>
                    </div>
                </div>
            </div>
            <div className='brand-bar'>
                <a href="https://explosion-creativa.com" target="_blank" rel="noopener noreferrer" className='brand-link'>
                    Desarrollado por: Explosión Creativa
                </a>
            </div>
        </>
    )
}
